import Et3Button from "../../../../core/et3-button";
import ET3Div from "../../../../core/et3-div";
import { withLiteObserverAndTheme } from "../../../../core/et3-enhanced-render";
import getCSRReceiptStore from "../../../../stores/csr-store/csr-receipt-event-count";

const MyCSRReceiptEventCountForm = withLiteObserverAndTheme((props) => {
  const { theme } = props;
  const { colors } = theme;

  return (
    <ET3Div
      isScrollable={false}
      isExtendable={false}
      fDirection="column"
      justifyContent="flex-start"
      alignItems="flex-start"
      withShadow={false}
      width={1500}
      height={50}
      color={colors.all.transparent}
      style={{}}
      onClick={() => {}}
    >
      <Et3Button
        onClick={async () => {
          await getCSRReceiptStore().getCSRReceiptCompensation();
        }}
        isEnabled={true}
        size="LARGE"
        text="GET"
        type="GET"
      />
    </ET3Div>
  );
});
export default MyCSRReceiptEventCountForm;
